export enum KRType {
    KRO2007,
    KRTZ2007,
    KRO2020,
    KRTZ2020
} 